import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { styled } from "@mui/material/styles";

import { makeStyles } from "@mui/styles";
// import Tooltip from '@material-ui/core/Tooltip';
// import InfoIcon from '@material-ui/icons/Info';
// import { handleNumber } from '../../../../common/method/displayData';

let useStyles = makeStyles(() => ({
  tables: {
    fontFamily: "iransans",

    "& thead th:not(:first-child)": {
      textAlign: "center",
    },

    "& thead th": {
      fontWeight: "500",
      fontSize: "18px",
      padding: "5px 0px",
      color: "#CECECE",
      borderBottom: "none",
    },

    "& tbody tr td": {
      fontSize: "14px",
      padding: 0,
      border: "none",
    },

    "& tbody tr td:not(:first-child)": {
      textAlign: "center",
    },

    "& thead tr th:first-child , & tbody tr td:first-child": {
      paddingRight: 9,
    },
    // '& tbody tr td:first-child': {
    //     paddingRight:10,
    // },
    "& tbody tr": {
      borderBottom: "1px solid #EFEFEF",
    },

    "& tbody tr:last-child ": {
      borderBottom: "none !important",
    },
  },
  tooltip: {
    maxWidth: 250,
    fontSize: 12,
    padding: 5,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "& td": {
    height: "50px !important",
  },
  "& td div": {
    lineHeight: 1.8,
    textAlign: "center",
    // background: "#D62D4D",
    borderRadius: 100,
    color: "white",
    display: "inline-block",
    width: 100,
    marginRight: 15,
    marginLeft: 15,
    fontSize: 12,
  },

  // "& td div.green": {
  //     background: '#099C55'
  // },
  "& td span": {
    width: 150,
    display: "block",
  },
  "&:nth-of-type(odd)": {},
  "&:last-child td, &:last-child th , &:last-child tr": {},
}));

export default function Index({ color, data, bgcolor, TypeRisk }) {
  let classes = useStyles();

  return (
    <TableContainer className="mt-6 ">
      <Table aria-label="simple table" className={classes["tables"]}>
        <TableHead className="bg-gray-200 p-4">
          <TableRow>
            <TableCell style={{ color: "black" }} className="text-black">
              عنوان
            </TableCell>
            <TableCell style={{ color: "black" }} align="left">
              کاربر
            </TableCell>
            <TableCell style={{ color: "black" }} align="left">
              میانگین کاربران
            </TableCell>
            <TableCell style={{ color: "black", minWidth: 100 }} align="left">
              شاخص کل
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, index) => (
            <StyledTableRow
              key={index}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                backgroundColor: index % 2 === 1 ? "#e1e1e155" : "",
              }}
            >
              <TableCell>
                <span>{row.title}</span>
              </TableCell>
              <TableCell align="left" style={{ direction: "ltr" }}>
                <div
                  style={{
                    backgroundColor:
                      row.user !== "-" &&
                      row.user !== null &&
                      row.user !== undefined
                        ? row.key.includes("return")
                          ? bgcolor(row.user)
                          : TypeRisk(row.user)?.color
                        : "-",
                  }}
                >
                  {row.user !== "-" &&
                  row.user !== null &&
                  row.user !== undefined
                    ? row.key.includes("return")
                      ? (parseFloat(row.user) * 100).toFixed(2) + "%"
                      : TypeRisk(row.user)?.title
                    : "-"}
                </div>
              </TableCell>

              <TableCell align="left" style={{ direction: "ltr" }}>
                <div
                  style={{
                    backgroundColor:
                      row.userAverage !== "-" &&
                      row.userAverage !== null &&
                      row.userAverage !== undefined
                        ? row.key.includes("return")
                          ? bgcolor(row.userAverage)
                          : TypeRisk(row.userAverage)?.color
                        : "-",
                  }}
                >
                  {row.userAverage !== "-" &&
                  row.userAverage !== null &&
                  row.userAverage !== undefined
                    ? row.key.includes("return")
                      ? (parseFloat(row.userAverage) * 100).toFixed(2) + "%"
                      : TypeRisk(row.userAverage)?.title
                    : "-"}
                </div>
              </TableCell>

              <TableCell align="left" style={{ direction: "ltr" }}>
                {index < 3 ? (
                  <div
                    style={{
                      backgroundColor:
                        row.userMarket !== "-" &&
                        row.userMarket !== null &&
                        row.userMarket !== undefined
                          ? row.key.includes("return")
                            ? bgcolor(row.userMarket)
                            : TypeRisk(row.userMarket)?.color
                          : "-",
                    }}
                  >
                    {row.userMarket !== "-" &&
                    row.userMarket !== null &&
                    row.userMarket !== undefined
                      ? row.key.includes("return")
                        ? (parseFloat(row.userMarket) * 100).toFixed(2) + "%"
                        : TypeRisk(row.userMarket)?.title
                      : "-"}
                  </div>
                ) : (
                  <>-</>
                )}
              </TableCell>
              {/* <TableCell align="left" style={{ color: color(row.D) }}>{row.D}</TableCell> */}
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
